if (!customElements.get('countdown-timer-badge')) {
  class CountdownTimerBadge extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.timer = null;
    }

    connectedCallback() {
      const endDateStr = this.getAttribute('end-date');
      if (!endDateStr) {
        return;
      }

      this.endDate = new Date(endDateStr).getTime();
      this.render();
      this.startCountdown();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    startCountdown() {
      const update = () => {
        const now = new Date().getTime();
        const distance = this.endDate - now;

        if (distance <= 0) {
          this.render("Ends in: 0D:00:00:00");
          clearInterval(this.timer);
          this.parentElement.remove();
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const formattedTime = `${this.dataset.timerText} ${days}D:` +
                              `${String(hours).padStart(2, '0')}:` +
                              `${String(minutes).padStart(2, '0')}:` +
                              `${String(seconds).padStart(2, '0')}`;

        this.render(formattedTime);
      };

      update();
      this.timer = setInterval(update, 1000);
    }

    render(content = '') {
      this.shadowRoot.innerHTML = `
        <span>${content}</span>
      `;
    }
  }

  customElements.define('countdown-timer-badge', CountdownTimerBadge);
}
